import { useEffect, useState } from 'react';
import { FaWhatsapp } from 'react-icons/fa6';
import { apiGetSiteSection } from '../../api';

const WhatsAppButton = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    apiGetSiteSection('contact_settings')
      .then(({ data }) => setSettings(data?.[0] || null))
      .catch(() => setSettings(null));
  }, []);

  if (!settings?.whatsappUrl || settings.whatsappEnabled === false) return null;

  return (
    <a
      href={settings.whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={settings.whatsappLabel || 'WhatsApp'}
      title={settings.whatsappLabel || 'WhatsApp'}
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-110 focus:outline-none focus:ring-2 focus:ring-[#25D366] focus:ring-offset-2"
    >
      <FaWhatsapp className="text-3xl" aria-hidden="true" />
    </a>
  );
};

export default WhatsAppButton;
